import React from 'react';
import { observer } from 'mobx-react-lite';
import { useAppStateContext } from 'src/AppState/AppState';
import {
    TabNav,
    TabNavItem,
} from 'src/components/CustomersBar/CustomerTab/TransactionHistoryTab/TransactionHistoryTab.style';

type TransactionHistoryTabItemsRouteType = 'all' | 'into' | 'out';

interface MenuItemsType {
    id: TransactionHistoryTabItemsRouteType;
    label: string;
    onClick: () => void;
}

export const TransactionHistoryTabItems = observer((): JSX.Element | null => {
    const { routerBackoffice } = useAppStateContext();
    const customerParams = routerBackoffice.getParametersString('customers', 'tab.tab.tab') ?? 'all';

    const isTabActive = (label: string): boolean => {
        return customerParams === label;
    };

    const menuItems: Array<MenuItemsType> = [
        {
            id: 'all',
            label: 'All Transactions',
            onClick: (): void => routerBackoffice.redirectToTransactionHistoryAll(),
        },
        {
            id: 'into',
            label: 'Incoming',
            onClick: (): void => routerBackoffice.redirectToTransactionHistoryIncoming(),
        },
        {
            id: 'out',
            label: 'Outgoing',
            onClick: (): void => routerBackoffice.redirectToTransactionHistoryOutgoing(),
        },
    ];

    return (
        <TabNav>
            {menuItems.map((linkItem) => (
                <TabNavItem
                    key={linkItem.id}
                    isActive={isTabActive(linkItem.id)}
                    onClick={linkItem.onClick}
                >
                    {linkItem.label}
                </TabNavItem>
            ))}
        </TabNav>
    );
});
